import { useOrgSync as useOrgSyncBase } from '@osnova/org-sync/react';

/**
 * Хук для синхронизации организации в main-layout
 * Обертка над библиотекой @osnova/org-sync
 */
export function useOrgSync() {
  return useOrgSyncBase({
    source: 'main-layout',
    logPrefix: '[MainLayout]',
    enableLogging: true,
    enablePersistence: true,
  });
}
